import Vue from 'vue'
import i18n from '@ms/lang/i18n.js'
import { isIosApp } from 'wap/hybrid/device.js'
import { shareToAppPlatform } from 'wap/hybrid'
import Share from './main.vue'

const ShareConstructor = Vue.extend(Share)

let shareInstance = null
let currentNode = null

const share = function (options = {}) {
  // ios app webview 内直接调用 app share 方法
  if (isIosApp()) {
    const imgData = options.shareImgs?.[0] || ''
    const isBase64 = /^data:.*;base64/.test(imgData)
    return shareToAppPlatform({
      title: options.shareTitle || '',
      description: options.shareTopTips || '',
      url: options.shareUrl || location.href,
      content: options.shareText ? encodeURIComponent(options.shareText) : '',
      image: isBase64 ? imgData : '',
      imageUrl: !isBase64 ? imgData : ''
    })
  }

  shareInstance = new ShareConstructor({
    i18n,
    propsData: {
      ...options
    }
  })
  shareInstance.$mount()
  if (currentNode) {
    document.body.removeChild(currentNode)
  }
  currentNode = shareInstance.$el
  document.body.appendChild(shareInstance.$el)

  shareInstance.visible = true
}

export default share
